import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface CombinedFile {
  files: File[];
  card: string;
}

export interface MissingField {
  label: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class UploadSummaryService {
  private combinedFilesSubject = new BehaviorSubject<CombinedFile[]>([]);
  public combinedFiles$ = this.combinedFilesSubject.asObservable();

  private missingFieldsSubject = new BehaviorSubject<MissingField[]>([]);

  setFiles(files: CombinedFile[]): void {
    this.combinedFilesSubject.next(files);
  }

  getFiles(): CombinedFile[] {
    return this.combinedFilesSubject.value;
  }

  clearFiles(): void {
    this.combinedFilesSubject.next([]);
  }

  setMissingFields(fields: MissingField[]): void {
    this.missingFieldsSubject.next(fields);
  }

  getMissingFields(): MissingField[] {
    return this.missingFieldsSubject.value;
  }

  clearMissingFields(): void {
    this.missingFieldsSubject.next([]);
  }
}
